import { environment } from '@env/environment';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import 'rxjs/add/operator/finally';
import { AuthenticationService, GlobalInfoService } from '@app/core';
import { HomeDataService } from './shared/home.data.service';
import { Const, DetalleVistaDinamica } from '@app/shared';
import { Subject } from 'rxjs';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { VistaSolicitudesVital } from '@app/shared/models/solicitudes-vital.model';

@Component({
  selector: 'iw-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  providers: [HomeDataService]
})
export class HomeComponent implements OnInit, OnDestroy {

  // Contiene las vistas dinamicas
  detailDynamicViews: DetalleVistaDinamica[] = [];
  // contiene la informacion de la vista de solicitudes de vital
  requestVitalView: VistaSolicitudesVital = null;
  // Activa la pestaña de solicitudes vital
  activateAccessTabSolicitudesVital = false;
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // define si muestra la modal de usuario nuevo
  openModal: boolean = false;
  //modal
  modalRef: BsModalRef;
  //Referencia al modal personalizado
  @ViewChild("modalNewUser") modalNewUser: any;

  constructor(private gis: GlobalInfoService, private hds: HomeDataService, private as: AuthenticationService, private modal: BsModalService,) { }

  ngOnInit() {
    this.gis.set({ title: 'Gestión de procesos' });
    this.openModal = this.as.getChangePassword();
    if(this.openModal){
      this.modalRef = this.modal.show(this.modalNewUser, {
        class: "modal-lg",
        ignoreBackdropClick: true,
      });
    }
    if (environment.vistasDinamicas) {
      this.hds.getDynamicView().subscribe((data: DetalleVistaDinamica[]) => this.detailDynamicViews = data);
    }
    if (
      this.as.confirmPermission(
        Const.types_permissions.instanceProcess ,
        Const.types_action_permissions.viewTabRequestesVital)
    ) {
      this.hds.getVitalView().subscribe((data: VistaSolicitudesVital) => this.requestVitalView = data);
      this.activateAccessTabSolicitudesVital = true;
    }
  }


  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  /**
   *Cierra la modal
   *
   * @memberof HomeComponent
   */
  closeModal() {
    this.modalRef.hide();
  }

}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts